import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface FacesRatingBarUniDriver extends BaseUniDriver {
  selectRating(rating: number): Promise<void>;
  getSelectedRating(): Promise<number>;
}
